import Button from '@components/atoms/button'
import { FastlyImage } from '@components/common/image'
import { MASTER_CLASSES } from '@lib/data/course-landing-page'

const IMAGE_PATH = '/images/courses/'

type Props = {
  courseName: string
}

const MasterClasses = ({ courseName }: Props) => {
  const masterClasses = MASTER_CLASSES[courseName]

  return (
    <div className="mt-16 mb-10 flex flex-col text-grey">
      <h2 className="text-2xl font-700 leading-tight mb-8">
        {masterClasses.heading}
      </h2>
      <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-3 self-center">
        {masterClasses.contents.map((masterClass, i) => (
          <div
            key={i}
            className="flex flex-col rounded-md shadow-md hover:shadow-xl transition duration-500"
          >
            <FastlyImage
              src={`${IMAGE_PATH}${masterClass.image.name}.png`}
              webpSrc={`${IMAGE_PATH}${masterClass.image.name}.webp`}
              width={492}
              height={334}
              objectFit="fill"
              alt={masterClass.image.alt}
            />
            <h3 className="leading-tight font-600 p-3">{masterClass.title}</h3>
            <div className="p-3 mt-auto">
              <a href={masterClass.link} target="_blank" rel="noreferrer">
                <Button className="w-full p-0" variant="outline">
                  Watch masterclass
                </Button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
export default MasterClasses
